module.exports = __webpack_public_path__ + "img/choose-up-cadou.2b533dd9.png";